/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jan 08 2024
 **/

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { useFileManager } from "@/frameworks/core/hooks";
import { Divider, Icon, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import * as S from "./emotion";
import SubFolder from "../SubFolder";

export default function MyFolders() {
	const { getMyFolders, setCurrentFolder, myRoomID, currentFolder } = useFileManager();
	const [isOpen, setIsOpen] = useState(false);

	const { data: myFolders } = useQuery({
		queryKey: ["myFolders", myRoomID],
		queryFn: async () => {
			return await getMyFolders();
		},
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchInterval: 1000 * 60 * 5,
		enabled: myRoomID !== ""
	});

	const focus = () => {
		if (currentFolder.id === myRoomID) {
			if (currentFolder.isMyFile) {
				return true;
			}
			return false;
		}
		return false;
	};

	return (
		<>
			<S.MyFolderWrapper isOpen={isOpen}>
				<S.FileBoxWrapper
					gap={4}
					focus={focus()}
					verticalAlign="center"
					css={{ padding: "4px 6px" }}
					onClick={() => {
						setIsOpen(!isOpen);
						setCurrentFolder({
							id: myRoomID || "",
							name: _T("내 파일"),
							isMyFile: true,
							referenceType: "INDIVIDUAL",
							referenceID: myRoomID,
							all: false,
							folderType: "INDIVIDUAL"
						});
					}}
				>
					<S.MyFileArrowIcon open={isOpen} name="DownFilledBig16" size={16} />
					<Icon name="Filebox24" size={24} />
					<Typography typoSize="Title3" typoColor="neutral_80_100">
						{_T("내 파일")}
					</Typography>
				</S.FileBoxWrapper>

				<div css={{ width: "100%", padding: "16px 0" }}>
					<Divider type="line" />
				</div>

				<S.MyFolderList gap={4}>
					{myFolders?.map((folder) => {
						return (
							<SubFolder
								key={folder.id}
								folder={{
									...folder,
									isMyFile: true,
									referenceType: "INDIVIDUAL",
									referenceID: myRoomID,
									folderType: "INDIVIDUAL",
									parent: {
										id: myRoomID || "",
										name: _T("내 파일"),
										existsSubFolder: true,
										isMyFile: true,
										referenceType: "INDIVIDUAL",
										referenceID: myRoomID,
										folderType: "INDIVIDUAL"
									}
								}}
								focusedBy={currentFolder.id}
								onSelectFolder={(targetFolder) => {
									setCurrentFolder({
										id: targetFolder.id,
										name: targetFolder.name,
										isMyFile: true,
										referenceType: "INDIVIDUAL",
										referenceID: myRoomID,
										parent: targetFolder.parent,
										all: false,
										folderType: "INDIVIDUAL"
									});
								}}
							/>
						);
					})}
				</S.MyFolderList>
			</S.MyFolderWrapper>
		</>
	);
}
